const PRODUCTION_API_HOST = 'api.skupreme.com';

/** True unless the API base points at the production API host. */
export function isStagingApi(apiUrl: string): boolean {
  try {
    return new URL(apiUrl).hostname !== PRODUCTION_API_HOST;
  } catch {
    return true;
  }
}

export const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');
export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_STAFF_GOOGLE_CLIENT_ID ?? '';
export const IS_STAGING = isStagingApi(API_URL);
/** Google Workspace domain, passed to Google Identity Services as a hint only; the server checks it. */
export const GOOGLE_HOSTED_DOMAIN = 'skupreme.com';
